module.exports = __webpack_public_path__ + "static/media/notfound.75fcc1fd.gif";